/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Konfessionpartner1Inputs */



/**

* @param {_Field_Konfessionpartner1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_konfessionpartner1 = /** @type {((inputs?: _Field_Konfessionpartner1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Konfessionpartner1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Konfession des Ehegatten/Lebenspartners")
});
export { _field_konfessionpartner1 as "_field_konfessionPartner" }